import React, { useCallback, useState } from 'react';
import { useLoadingBackdrop } from 'hooks/useLoadingBackdrop';
import { message } from 'antd';
import _ from 'lodash';

import { Button } from 'ui-kit';

import { coHostCreate, ICoHost, useCoHostList } from 'api/co-hosts';
import CoHostModal from 'components/CoHosts/CoHostModal';

const AddCoHostButtonModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showLoading, hideLoading] = useLoadingBackdrop();

  const { mutate: updateCoHosts } = useCoHostList();

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    updateCoHosts();
    hideLoading();
  }, [isOpen, updateCoHosts, hideLoading]);

  const onSubmit = useCallback(
    ({ data }: { data: ICoHost }) => {
      showLoading();
      if (
        !_.isNull(data.phone_number) &&
        !data.is_request_sms_enabled &&
        !data.is_sales_sms_enabled &&
        !data.is_marketing_sms_enabled
      ) {
        message.error('Select the text info you would like your contact to receive.');
        return;
      }

      if (
        _.isNull(data.phone_number) &&
        (data.is_request_sms_enabled || data.is_sales_sms_enabled || data.is_marketing_sms_enabled)
      ) {
        message.error('Phone number is required to receive text info.');
        return;
      }

      coHostCreate({
        coHost: data,
      })
        .then(() => {
          message.success('Co-host contact created successfully!');
          updateCoHosts();
          closeModal();
        })
        .catch((error) => message.error(error.message));
      hideLoading();
    },
    [showLoading, hideLoading, closeModal, updateCoHosts],
  );

  return (
    <>
      <Button variant="contained" onClick={openModal}>
        Invite Co-hosts
      </Button>
      <CoHostModal initialData={null} isOpen={isOpen} onConfirm={onSubmit} onCancel={closeModal} />
    </>
  );
};

export default AddCoHostButtonModal;
